export interface Branch extends BranchInfo {
  branch_id: string | number;
}

export interface BranchLocation {
  about_equipmentshare_header: string;
  about_equipmentshare_text: string;
  city: string;
  description: string;
  get_directions_link: string;
  hours_of_operation_friday: string;
  hours_of_operation_monday: string;
  hours_of_operation_saturday: string;
  hours_of_operation_sunday: string;
  hours_of_operation_thursday: string;
  hours_of_operation_tuesday: string;
  hours_of_operation_wednesday: string;
  latitude: string;
  location_address: string;
  location_id: string;
  location_phone: string;
  longitude: string;
  name: string;
  request_service_link: string;
  slug: string;
  start_your_rental_link: string;
  state: string;
  state_name: string;
  zip_code: string;
  _id: string;
}

export interface BranchInfo {
  latlon_detail: {
    delivery_available: boolean;
    distance_miles: string;
  };
  rental_service_slug: string;
  rental_service_name: string;
  rental_service_rich_text_content: string;
  location: BranchLocation;
}

export interface BranchResponse extends Array<BranchInfo> {}

export enum LocationStatus {
  IS_LOADING = 'IS_LOADING',
  IS_EDITING = 'IS_EDITING',
  ERROR = 'ERROR',
}

export enum CurrentLocationStatus {
  IS_LOADING = 'IS_LOADING',
  BAD_CURRENT_LOCATION = 'BAD_CURRENT_LOCATION',
  BROWSER_PERMISSION_NOT_GRANTED = 'BROWSER_PERMISSION_NOT_GRANTED',
  ERROR = 'ERROR',
  NONE = 'NONE',
}

export interface UserLocation {
  address: string;
  street?: string;
  place_id: string;
  latitude: number;
  longitude: number;
  city: string;
  state: string;
  zip?: string;
}

export type GetUserLocationFromGeocodeResponseType = {
  postalCodeComponent?: ReverseGeocodeResponseResultType | undefined;
  countryComponent?: GoogleAddressComponent | undefined | null;
  cityComponent?: GoogleAddressComponent | undefined | null;
  stateComponent?: GoogleAddressComponent | undefined | null;
  streetAddress?: string | null;
  zip?: string;
  place_id?: string | undefined | null;
};

export interface GooglePlacesResponse {
  description: string;
  place_id: string;
}

export type ReverseGeocodeResponseResultType = {
  formatted_address: string;
  address_components: GoogleAddressComponent[];
  place_id: string;
  types: string[];
};

export interface ReverseGeocodeResponse {
  results: ReverseGeocodeResponseResultType[];
  status: string;
}

export interface GeocodeLocationResponse {
  results: {
    address_components: GoogleAddressComponent[];
    geometry: {
      location: {
        lat: number;
        lng: number;
      };
    };
  }[];
  status: string;
}

export interface GoogleAddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}

export enum LocationSelector {
  NONE = 'NONE',
  DROPDOWN = 'DROPDOWN',
  MODAL = 'MODAL',
  BOTTOM_SHEET = 'BOTTOM_SHEET',
}

export type StateRecord = {
  value: string;
  label: string;
  abbreviation: string;
}

export interface StreetAddressComponents {
  street_number: string | null;
  route: string | null;
  subpremise: string | null;
}

export interface LocationFinderOptions {
  aggs?: LocationFinderAggsKey[];
  filter?: {
    states?: string[]
  };
}

export enum LocationFinderAggsKey {
  LOCATION_STATE_CITY = 'location.state_city',
}

export interface LocationFinderAgg {
  total: number;
  /**
   * First level buckets: For example: States
   */
  buckets: {
    key: string;
    count: number;
  /**
   * Nested buckets: For example: Cities
   */
    buckets: {
      key: string;
      count: number;
    }[];
  }[];
}

export interface LocationFinderAggs {
  [LocationFinderAggsKey.LOCATION_STATE_CITY]?: LocationFinderAgg; 
}

export interface LocationFinderResponse {
  aggs?: LocationFinderAggs;
}
